import { Influencer, Post, SocialAccount } from "types/influencer"
import InfluencerCardHeader from "./InfluencerCardHeader"
import React from "react"
import { formatNumber } from "utils/helpers"
import InfluencerContent from "./InfluencerContent"
import { AppDispatch } from "store"
import { useDispatch } from "react-redux"
import { showInfluencerPostModal, showSocialPostModal } from "slices/ui/reducer"
import { ACCOUNT_NOT_FOUND_MSG } from "constants/global"
import { SocialPost } from "types/campaign/collaborations"

interface InfluencerProfileProps {
    influencer?: Influencer,
    socialAccount: SocialAccount
}
const InfluencerProfile: React.FC<InfluencerProfileProps> = ({ influencer, socialAccount }) => {

    const dispatch: AppDispatch = useDispatch();

    const handleMediaClick = (post: SocialPost) => {
        dispatch(showSocialPostModal({ postId: post.uuid, socialAccount }))
    }

    return (
        <React.Fragment>
            <div className="border-bottom-1">
                <div className="p-4">
                    <InfluencerCardHeader name={influencer?.name ?? (socialAccount?.name ?? `@${socialAccount?.handle}`)} borderBottom={false} socialAccount={socialAccount} gender={influencer?.gender_name} location={influencer?.location} />
                </div>
            </div>
            {
                socialAccount ? (
                    <InfluencerContent onMediaClick={handleMediaClick} socialAccountId={socialAccount.uuid} socialAccount={socialAccount} influencerId={influencer?.uuid} />
                ) : (
                    <div className="account-not-available-card influncer-profile-content">
                        <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default InfluencerProfile